import * as tslib_1 from "tslib";
/* I10 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
import { useFlag } from '../../redux/flags/hooks/useFlag';
var Comment = function (props) {
    var isUplifted = useFlag('actionbar_phase_1');
    return (React.createElement(IconWrap, tslib_1.__assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", null, isUplifted ? (React.createElement("polygon", { points: "11.256 22 8.585 17.819 2 17.819 2 6.219 6.122 2 22 2 22 13.608 17.885 17.819 13.927 17.819" })) : (React.createElement("path", { d: "M5 5h14v11.384H8.78L5 20z" }))))));
};
Comment.displayName = 'Comment';
export default Comment;
//# sourceMappingURL=Comment.js.map